export const CTA_TYPE_OPTIONS = [
	{ id: 'IN_APP', label: 'IN_APP' },
	{ id: 'EXTERNAL_LINK', label: 'EXTERNAL_LINK' },
	{ id: 'WEBVIEW_LINK', label: 'WEBVIEW_LINK' }
];

export const CTA_VALUE_OPTIONS = [
	{ id: 'DASHBOARD', label: 'DASHBOARD' },
	{ id: 'PLAY_ONLINE', label: 'PLAY_ONLINE' },
	{ id: 'SEE_MORE_INFO', label: 'SEE_MORE_INFO' },
	{ id: 'PROFILE', label: 'PROFILE' },
	{ id: 'REFER', label: 'REFER' },
	{ id: 'SETTINGS', label: 'SETTINGS' },
	{ id: 'WALLET', label: 'WALLET' },
	{ id: 'WITHDRAWAL', label: 'WITHDRAWAL' },
	{ id: 'KYC', label: 'KYC' },
	{ id: 'HOW_TO_PLAY', label: 'HOW_TO_PLAY' },
	{ id: 'ADD_MONEY', label: 'ADD_MONEY' },
	{ id: 'NOTIFICATION', label: 'NOTIFICATION' },
	{ id: 'HELPDESK', label: 'HELPDESK' },
	{ id: 'GAME_MANAGEMENT', label: 'GAME_MANAGEMENT' },
	{ id: 'ADD_BANK', label: 'ADD_BANK' },
	{ id: 'ADD_UPI', label: 'ADD_UPI' },
	{ id: 'MTT_TOURNAMENT', label: 'MTT_TOURNAMENT' },
	{ id: 'APP_RESTART', label: 'APP_RESTART' },
	{ id: 'TRANSACTION_HISTORY', label: 'TRANSACTION_HISTORY' },
	{ id: 'PWF', label: 'PWF' },
	{ id: 'PAYMENTS', label: 'PAYMENTS' }
];

export const HH_ZUPEE_GAMES = [
	{ id: 'LUDO', label: 'LUDO' },
	{ id: 'NINJA', label: 'NINJA' },
	{ id: 'TURBO', label: 'TURBO' },
	{ id: 'SNLT', label: 'SNLT' },
	{ id: 'TC', label: 'TC' }
];

export const HAPPY_HOUR_TYPES = [
	{ id: 'DEF', label: 'DEF' },
	{ id: 'BONUS_REWARDS', label: 'BONUS_REWARDS' },
	{ id: 'BONUS_PERCENTAGE', label: 'BONUS_PERCENTAGE' }
];
